import SearchResultMain from './modules/search/searchResultMain';
new SearchResultMain();
